import { combineReducers } from "redux";
import { getErrorReducer } from "../utils/reducer-generators";
import { CREATE_BOOKING, CREATE_BOOKING_END, CREATE_BOOKING_INIT } from "../constants/create-booking";
import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils";
import { ANONYMOUS, ERROR, INIT, LOADING, OK } from "../constants";
import { Status } from "../types";
import { Action } from "../models/create-booking";

function status(state: Status = ANONYMOUS, action: Action): Status {
  switch (action.type) {
    case getRequestActionType(CREATE_BOOKING):
      return LOADING;
    case getSuccessActionType(CREATE_BOOKING):
      return OK;
    case getFailureActionType(CREATE_BOOKING):
      return ERROR;
    case CREATE_BOOKING_INIT:
      return INIT;
    case CREATE_BOOKING_END:
      return ANONYMOUS;
    default:
      return state;
  }
}

export default combineReducers({
  status,
  error: getErrorReducer([CREATE_BOOKING]),
});
